import { GuideBanner } from "src/components/Guide/GuideBanner";
import { UserStatisticsModal } from "src/components/Modals/StatisticsModals/UserStatisticsModal";
import { isFaqEnabled } from "src/hooks/useAppConfig";

import Courses from "./Courses";
import DeckToResolveBox from "./DeckToResolveBox";
import ExamsBox from "./ExamsBox/ExamsBox";
import { News } from "./News/News";

export default function Main() {
	return (
		<div className="flex flex-col gap-12">
			{isFaqEnabled() && <GuideBanner />}
			<News />
			<div className="main-box pb-12">
				<div className="feature-box">
					<ExamsBox />
					<Courses />
				</div>
				<div className="feature-box">
					<DeckToResolveBox />
					<UserStatisticsModal />
				</div>
			</div>
		</div>
	);
}
